import { useEffect, useState } from 'react'
import classes from './Pagination.module.css'

import PaginationButtonPage from './PaginationButtonPage'
import PaginationButton from './PaginationButton'
import PerPage from './PerPage'
import PaginationGoTo from './PaginationGoTo'

const Pagination = ({data, isSimple, apiType, hidePerPage}) => {

    const [pageList, setPageList] = useState(null)

    useEffect(() => {
        let pagesList = []
        let i = 0
        if (data.meta.last_page > 5) {
            while (pagesList.length < 5) {
                let a = (data.meta.current_page + i) - 4
    
                if (data.meta.current_page > 2) {
                    a = (data.meta.current_page + i) - 2
                }
    
                if (data.meta.current_page > data.meta.last_page - 2) {
                    a = (data.meta.current_page + i) - 3
                }
                if (data.meta.current_page > data.meta.last_page - 1) {
                    a = (data.meta.current_page + i) - 4
                }
    
                if (a > 0 && a <= data.meta.last_page) {
                    pagesList.push(a)
                }
                i++
            }
    
            if (pagesList.length > 0) {
                setPageList(pagesList)
            } else {
                setPageList(null)
            }
        } else {
            for (let index = 0; index < Number(data.meta.last_page); index++) {
                pagesList.push(index+1)                
            }

            if (pagesList.length > 0) {
                setPageList(pagesList)
            } else {
                setPageList(null)
            }
        }
        

        // currentPage(data.meta.current_page)
    }, [data])   


    return <div className={classes.pagination}>
        {!isSimple && <div>
            Viewing {data.meta.from}-{data.meta.to} of {data.meta.total} results
        </div>}
        <div className={`${classes.pagination_inner} ${isSimple ? classes.pagination_inner_simple : ''}`}>
            {!hidePerPage && <PerPage data={data} apiType={apiType} />}
            <div className={classes.button_group_prev_next}>
                {!isSimple && <PaginationButton data={data} page={data.links.first} isDisabled={data.meta.current_page == 1} apiType={apiType} type="first">
                    {/* <i className='ti ti-chevrons-left'></i> */}
                    First
                </PaginationButton>}
                <PaginationButton data={data} page={data.links.prev} isDisabled={data.meta.current_page == 1} apiType={apiType} type="prev">
                    {/* <i className='ti ti-chevron-left'></i> */}
                    Previous
                </PaginationButton>
            </div>

            {!isSimple && pageList && pageList.length > 0 && 
                <>
                {pageList[0] !== 1 && <>...</>}
                </>
            }
            {!isSimple && pageList && pageList.map(item => (
                <PaginationButtonPage key={item} data={data} page={item} apiType={apiType}>{item}</PaginationButtonPage>
            ))}
            {isSimple && <PaginationButtonPage data={data} page={data.meta.current_page} apiType={apiType}>{data.meta.current_page}</PaginationButtonPage>}  


            {!isSimple && pageList && pageList.length > 0 && 
                <>
                {pageList[pageList.length - 1] !== data.meta.last_page && <>...</>}
                </>
            }          

            <div className={classes.button_group_prev_next}>
                <PaginationButton data={data} page={data.links.next} isDisabled={data.meta.current_page == data.meta.last_page} apiType={apiType} type="next">
                    {/* <i className='ti ti-chevron-right'></i> */}
                    Next
                </PaginationButton>
                {!isSimple && <PaginationButton data={data} page={data.links.last} isDisabled={data.meta.current_page == data.meta.last_page} apiType={apiType} type="last">
                    {/* <i className='ti ti-chevrons-right'></i> */}
                    Last
                </PaginationButton>}
            </div>

            {!isSimple && data.meta.last_page > 10 && <PaginationGoTo data={data} apiType={apiType} />}
        </div>
    </div>
}

export default Pagination